import { TextView } from './text';
import {ColorUtils} from '@/model/project/utils/colorutils'
import { LineColorProperty } from "./properties/linecolorproperty";
import { FillColorProperty } from "./properties/fillcolorproperty";
import { TextColorProperty } from "./properties/textcolorproperty";
import Konva from "konva";
import { TextInputProperty } from "./properties/textinputproperty";
import { StringUtils } from "../utils/stringutils";
import { OutputProperty } from "./properties/outputproperty";
import { DialogBox } from "../dialogbox";
import dialogboxModule from "@/store/dialogbox.module";
import { Value } from "../value";


export class EditView extends TextView{

    public drawObject():void{
        super.initObject();

        if (this.linewidth==null || this.linewidth<=0) this.linewidth = 1
        if (this.textplacement<0 || this.textplacement>3) this.textplacement = 0

        let fillcolor = '0xffffff00';
       
        fillcolor = this.fillcolor;
            const fillprop =this.properties==null?null:this.properties['fillcolor'];
            if (fillprop!=null){	
                const fillcolorproperty:FillColorProperty =Object.assign(new FillColorProperty(), fillprop);
                if (fillcolorproperty!=null) 
                        fillcolor = fillcolorproperty.getColor(this.tagnames, this.fillcolor)     
            }	
        
        const fillcolor2:string = ColorUtils.convertformat(fillcolor);
        const rect = new Konva.Rect({
            x: 0,
            y: 0,
            width: this.width,
            height: this.height,
            fill: fillcolor2,

          });
          this.node.add(rect)

          let text = this.text;
         
          let textcolor = this.textcolor;
            const textcolorprop = this.properties==null?null:this.properties['textcolor'];
            if (textcolorprop!=null){	
                const textcolorproperty:TextColorProperty =Object.assign(new TextColorProperty(), textcolorprop);
                if (textcolorproperty!=null) 
                    textcolor = textcolorproperty.getColor(this.tagnames, this.textcolor)
            }
            const outputprop = this.properties==null?null:this.properties['output'];
            if (outputprop!=null){
              const outputproperty:OutputProperty=Object.assign(new OutputProperty(), outputprop);
              if (outputproperty!=null){
                const outputtag = outputproperty.getTag(this.tagnames);
                if (outputtag!=null){
                    if (outputtag.datatype==7 || outputtag.datatype==8 || outputtag.datatype==0)
                        text = outputtag.tagvalue
                    else
                        text = Number(+outputtag.tagvalue).toString();

                }
                  this.node.on('mousedown touchstart', function () {
                          const dialogbox:DialogBox = new DialogBox();
                          dialogbox.enable = true;
                          dialogbox.title = outputproperty.title;
                          dialogbox.tagname = outputproperty.path;
                          dialogboxModule.setDialogBox(dialogbox);
                    });
              }
            }
            const Text = new Konva.Text({
                x: 2*this.linewidth+1,
                y: this.linewidth,
                verticalAlign:"middle",
                width: this.width-4*this.linewidth-1,
                height: this.height-1*this.linewidth,
                text: text,
                fontSize: this.fontsize,
                fontFamily: StringUtils.getFontFamily(this.fonttype),
                fontStyle: StringUtils.getFontStyle(this.fonttype),
                align:StringUtils.getTextPlacement(this.textplacement),
                fill: ColorUtils.convertformat(textcolor),
                textDecoration:this.underline?"underline":""
              });
              
              this.node.add(Text);
    }

   
}